"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPrimaryEmailDomain = exports.getPrimaryBlogDomain = exports.getSelectedDomainId = exports.getSelectedDomain = exports.getIsAllDomainsSelected = exports.getDomainFromId = exports.getFetchBlogDomainsRequestStatus = exports.getFetchDomainsRequestStatus = exports.getDomainOptionsExcludingInternalDomains = exports.getDomainOptionsIncludingAllDomains = exports.getDomainsAsSelectInputOptionsWithNoScheme = exports.getBlogDomainsAsSelectInputOptions = exports.getAllDomainsAsSelectInputOptions = exports.getBlogDomains = exports.getAllDomains = exports.getDomainsAsSelectInputOptions = void 0;

var _immutable = require("immutable");

var _reselect = require("reselect");

var _actions = require("./actions");

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _constants = require("settings-ui-sdk/SiteSettings/constants");

var _I18n = _interopRequireDefault(require("I18n"));

var getDomainsAsSelectInputOptions = function getDomainsAsSelectInputOptions(domains) {
  return domains.reduce(function (acc, domain) {
    var scheme = domain.get('isSslOnly') ? 'https://' : 'http://';
    acc.push({
      value: domain.get('domain'),
      text: "" + scheme + domain.get('domain')
    });
    return acc;
  }, []);
};

exports.getDomainsAsSelectInputOptions = getDomainsAsSelectInputOptions;

var getAllDomains = function getAllDomains(state) {
  return state.domains.get('allDomains');
};

exports.getAllDomains = getAllDomains;

var getBlogDomains = function getBlogDomains(state) {
  return state.domains.get('blogDomains');
};

exports.getBlogDomains = getBlogDomains;
var getAllDomainsAsSelectInputOptions = (0, _reselect.createSelector)([getAllDomains], function (domains) {
  return getDomainsAsSelectInputOptions(domains);
});
exports.getAllDomainsAsSelectInputOptions = getAllDomainsAsSelectInputOptions;
var getBlogDomainsAsSelectInputOptions = (0, _reselect.createSelector)([getBlogDomains], function (domains) {
  return getDomainsAsSelectInputOptions(domains);
});
exports.getBlogDomainsAsSelectInputOptions = getBlogDomainsAsSelectInputOptions;
var getDomainsAsSelectInputOptionsWithNoScheme = (0, _reselect.createSelector)([getAllDomains], function (domains) {
  return domains.reduce(function (acc, domain) {
    acc.push({
      value: domain.get('domain'),
      text: domain.get('domain'),
      isInternal: domain.get('isInternalDomain')
    });
    return acc;
  }, []);
});
exports.getDomainsAsSelectInputOptionsWithNoScheme = getDomainsAsSelectInputOptionsWithNoScheme;
var getDomainOptionsIncludingAllDomains = (0, _reselect.createSelector)([getDomainsAsSelectInputOptionsWithNoScheme], function (domainOptions) {
  var allDomainsOption = {
    text: _I18n.default.text('marketing.pages.domainSelector.allDomainsWithInheritance'),
    value: _constants.ALL_DOMAINS_KEY
  };
  return [allDomainsOption].concat(domainOptions);
});
exports.getDomainOptionsIncludingAllDomains = getDomainOptionsIncludingAllDomains;
var getDomainOptionsExcludingInternalDomains = (0, _reselect.createSelector)([getDomainsAsSelectInputOptionsWithNoScheme], function (domainOptions) {
  var options = domainOptions.filter(function (domain) {
    return !domain.isInternal;
  });
  var allDomainsOption = {
    text: _I18n.default.text('marketing.pages.domainSelector.allDomains'),
    value: _constants.ALL_DOMAINS_KEY
  };
  return [allDomainsOption].concat(options);
});
exports.getDomainOptionsExcludingInternalDomains = getDomainOptionsExcludingInternalDomains;
var getFetchDomainsRequestStatus = (0, _getRequestStatus.default)(_actions.DomainActionTypes.FETCH_DOMAINS);
exports.getFetchDomainsRequestStatus = getFetchDomainsRequestStatus;
var getFetchBlogDomainsRequestStatus = (0, _getRequestStatus.default)(_actions.DomainActionTypes.FETCH_BLOG_DOMAINS);
exports.getFetchBlogDomainsRequestStatus = getFetchBlogDomainsRequestStatus;

var getDomainFromId = function getDomainFromId(state, domainId) {
  if (isNaN(Number(domainId))) {
    return null;
  }

  return getAllDomains(state).get(Number(domainId)) || null;
};

exports.getDomainFromId = getDomainFromId;

var getIsAllDomainsSelected = function getIsAllDomainsSelected(state, domainIdOrAllDomainsKey) {
  return domainIdOrAllDomainsKey === _constants.ALL_DOMAINS_KEY;
};

exports.getIsAllDomainsSelected = getIsAllDomainsSelected;
var getSelectedDomain = (0, _reselect.createSelector)([getIsAllDomainsSelected, getDomainFromId], function (isAllDomainsSelected, domain) {
  if (isAllDomainsSelected) {
    return _constants.ALL_DOMAINS_KEY;
  } else if (domain) {
    return domain.get('domain');
  }

  return '';
});
exports.getSelectedDomain = getSelectedDomain;
var getSelectedDomainId = (0, _reselect.createSelector)([getIsAllDomainsSelected, getDomainFromId], function (isAllDomainsSelected, domain) {
  if (!isAllDomainsSelected && domain) {
    return domain.get('id');
  }

  return null;
});
exports.getSelectedDomainId = getSelectedDomainId;
var getPrimaryBlogDomain = (0, _reselect.createSelector)([getBlogDomains], function (domains) {
  return domains.find(function (domain) {
    return domain.get('primaryBlogPost');
  }, '', (0, _immutable.Map)());
});
exports.getPrimaryBlogDomain = getPrimaryBlogDomain;
var getPrimaryEmailDomain = (0, _reselect.createSelector)([getAllDomains], function (domains) {
  return domains.find(function (domain) {
    return domain.get('primaryEmail');
  }, null, (0, _immutable.Map)());
});
exports.getPrimaryEmailDomain = getPrimaryEmailDomain;